import { Link } from "react-router-dom";
import { editAndReturn } from "@/base";
import {
  WC_PAGE_TITLES,
  wcStepPath,
  type MissingItem,
} from "@/lib/submissions/wc/review";

/** What the application still needs (BRK-S305), each linked to the page that
 *  asks it, which returns to the last step once saved (BRK-S387); a field no
 *  page asks is listed unlinked. Used by the last step after a refused
 *  Submit. */
export function MissingChecklist({
  id,
  items,
  existingAccountId,
}: {
  id: string;
  items: readonly MissingItem[];
  existingAccountId?: string | null;
}) {
  return (
    <ul className="flex list-inside list-disc flex-col gap-1">
      {items.map((item) => (
        <li key={`${item.step ?? "other"}:${item.key}`} className="break-words">
          {item.step ? (
            <>
              <Link
                to={
                  item.key === "ein" && existingAccountId
                    ? `/accounts/${encodeURIComponent(existingAccountId)}`
                    : editAndReturn(wcStepPath(id, item.step))
                }
                className="text-brk-accent hover:underline"
              >
                {item.label}
              </Link>
              <span className="text-xs text-brk-dim">
                {" "}
                on{" "}
                {item.key === "ein" && existingAccountId
                  ? "the account’s Details tab"
                  : WC_PAGE_TITLES[item.step]}
              </span>
            </>
          ) : (
            item.label
          )}
        </li>
      ))}
    </ul>
  );
}
